import "./BetTableCmeter.css";
import { userSiteAsset } from "../../../utils/userSiteAssets";
import { formatMinMax } from "../betTableBtable/oddsUtils";
import { formatBook } from "../../../utils/formatOdds";

// Casino Meter (cmeter) — admin view only. Original admin: two grey boxes (.cmeter
// .teen1dayleft / .teen1dayright, index.css) — "Low 34" / "High 37" title, dealt cards of
// that side, book bottom-left, R: min-max bottom-right. Feed: sub "Low" / "High",
// card "KCC,6DD,..." (A-9 → Low, 10/J/Q/K → High), rdesc "lowTotal,highTotal,..".
function splitDealt(cardString) {
  const low = [];
  const high = [];
  String(cardString || "").split(",").map((t) => t.trim()).forEach((code) => {
    if (!code || code === "1") return;
    const rank = code.slice(0, -2).toUpperCase();
    const num = parseInt(rank, 10);
    if (rank === "A" || rank === "1" || (!isNaN(num) && num <= 9)) low.push(code);
    else if (rank === "10" || ["J", "Q", "K"].includes(rank)) high.push(code);
  });
  return { low, high };
}

function Side({ label, item, total, cards, exposures, className }) {
  const n = parseFloat(exposures?.[label] ?? exposures?.[label.toLowerCase()]);
  const book = Number.isFinite(n) ? n : 0;
  return (
    <div className={className}>
      <div className="text-center">
        <span className="cmeter-title">{label}</span>
        {total > 0 && <span className="cmeter-total">{total}</span>}
      </div>
      <div className="casino-cards">
        {cards.map((code, i) => (
          <div key={`${code}-${i}`} className="casino-card-item">
            <div className="card-image"><img src={userSiteAsset(`assets/img/cards/${code}.jpg`)} alt={code} /></div>
          </div>
        ))}
      </div>
      <div className="meter_mm_book">
        <span className={`casino-book ${book > 0 ? "book-green" : "book-red"}`}>{formatBook(book)}</span>
        <span className="casino-min-max">
          R:<span>{formatMinMax(item?.min)}</span>-<span>{formatMinMax(item?.max)}</span>
        </span>
      </div>
    </div>
  );
}

export default function BetTableCmeter({ raw = {}, exposures = {} }) {
  const sub = Array.isArray(raw?.sub) ? raw.sub : [];
  const find = (nat) => sub.find((s) => s?.nat === nat);
  const { low, high } = splitDealt(raw?.card);
  const [lowTotal, highTotal] = String(raw?.rdesc || "").split(",").map((v) => parseInt(v, 10) || 0);

  return (
    <div className="casino-table cmeter cmeter-admin">
      <div className="casino-detail">
        <Side label="Low" item={find("Low")} total={lowTotal} cards={low} exposures={exposures} className="teen1dayleft" />
        <Side label="High" item={find("High")} total={highTotal} cards={high} exposures={exposures} className="teen1dayright" />
      </div>
    </div>
  );
}
